import { render, staticRenderFns } from "./ExamDetail.vue?vue&type=template&id=c545590a"
import script from "@/controllers/custom/exam/exam-detail.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/exam/exam-detail.js?vue&type=script&lang=js&external"
import style0 from "./ExamDetail.vue?vue&type=style&index=0&id=c545590a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports